<template>
  <el-dialog
    width="70%"
    class="min-w-330px"
    align-center
  >
    <template #header>
      <div class="fs-20px fw-500">
        切換品牌/場館
      </div>
    </template>
    <div class="overflow-y-auto fs-base" style="height: 450px;">
      <div v-if="loading" class="flex-fill d-flex h-100">
        <div class="m-auto spinner-border text-primary"></div>
      </div>
      <div v-else class="row gy-3 gx-0">
        <div
          class="col-lg-6 col-xl-4"
          v-for="(intro, index) in intro"
          :key="index"
        >
          <div class="d-flex mb-2">
            <div
              v-if="intro.imgBrandLogo?.sm?.key"
              class="ratio ratio-1x w-35px me-2"
            >
              <img
                :src="convertVirtualPathToRealPath(baseUrl, intro.imgBrandLogo?.sm?.value)"
                class="bg-contain w-35px"
                alt="brand logo"
              />
            </div>
            <div class="fs-fourthly text-success">{{ intro.title }}</div>
          </div>
          <ul class="ps-4">
            <li v-for="(site, index) in intro.sites" :key="index">
              <div class="fs-fifthly mb-1">
                <a
                  class="sites-link"
                  :href="`https://${site.url}`"
                  target="_blank"
                  rel="noopener"
                >
                  {{ site.title }}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { ConvertVirtualPathToRealPath } from '@/utils/urlHelper'

export default {
  props: {
    intro: {
      type: Array,
      required: true,
      default: () => []
    },
    loading: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_IMG_API.replace(/\/$/, ''),
    }
  },
  methods: {
    convertVirtualPathToRealPath(baseUrl, fileUrl) {
      return ConvertVirtualPathToRealPath(baseUrl, fileUrl)
    }
  }
}
</script>

<style>
a.sites-link {
  color: #1a1a1a;
}

a.sites-link:hover {
  color: #0367fc;
}
</style>
